import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { FloatingButton } from '../../components/feature/FloatingButton';
import { HeroSection } from './components/HeroSection';
import { ValuePropositionSection } from './components/ValuePropositionSection';
import { AssetValueSection } from './components/AssetValueSection';
import { ProcessSection } from './components/ProcessSection';
import { BenefitsSection } from './components/BenefitsSection';
import { LocationSection } from './components/LocationSection';
import { BuildingOverviewSection } from './components/BuildingOverviewSection';
import { BirdEyeViewSection } from './components/BirdEyeViewSection';
import { MoatownStorySection } from './components/MoatownStorySection';
import { NoticeSection } from './components/NoticeSection';
import { QnASection } from './components/QnASection';
import { ConsentFormSection } from './components/ConsentFormSection';
import { CommitteeAboutSection } from './components/CommitteeAboutSection';
import { ContactSection } from './components/ContactSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ValuePropositionSection />
        <AssetValueSection />
        <ProcessSection />
        <BenefitsSection />
        <LocationSection />
        <BuildingOverviewSection />
        <BirdEyeViewSection />
        <MoatownStorySection />
        <NoticeSection />
        <QnASection />
        <ConsentFormSection />
        <CommitteeAboutSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
};

export default HomePage;